import { render, staticRenderFns } from "./HumanResourcesKPI.vue?vue&type=template&id=cc396104&scoped=true"
import script from "./HumanResourcesKPI.vue?vue&type=script&lang=js"
export * from "./HumanResourcesKPI.vue?vue&type=script&lang=js"
import style0 from "./HumanResourcesKPI.vue?vue&type=style&index=0&id=cc396104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc396104",
  null
  
)

export default component.exports